/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 10:11:03
 */
export default{
    base:{
        search:'Search',
        add:'Add',
        edit:'Edit',
        save:'Save',
        modify:'Modify',
        delete:'Delete',
        download:'DownLoad',
        push:'Push',
        release:'Release',
        use:'Use',
        forbidden:'Forbidden',
        released:'Released',
        invalid:'Invalid',
        test:'Test',
        customCol:'Custom Columns',
        person:'Person Center',
        logout:'Logout',
        login:'Login',
        logoutMsg:'Confirm to exit the current login?',
        tip:'Tip',
        confirm:'Confirm',
        confirm2:'Confirm',
        cancel:'Cancel',
        copy:'Copy',
        cancelReplace:'Cancel Replace',
        revokeDelete:'Revoke Delete',
        reset:'Reset',
        yes:'Yes',
        no:'No',
        YES:'YES',
        NO:'NO',
        all:'All',
        uploadFirmware:'Upload Firmware',
        total:'Total',
        page:'Page',
        row:'Rows',
        upload:'Upload',
        enter:'Please Enter',
        select:'Please Select',
        great:'Great',
        homeTitle:"works of art don't have to follow trends, they can lead trends themselves",
        selectFile:'Select File',
        selectDateRange:'Please select a date range',
        noData:'No Data',
        noEmpty:'cannot be empty!',
        dataView:"DataView",
        downLoad:"DownLoad",
        close:"Close",
        refresh:'Refresh',
        currentDate:'Current Date',
        week:'Week',
        operate:'Operate',
        order_number:'No.',
        customColumns:'Custom Columns',
        delMsg:'Are you sure to delete?',
        uploadImg:'Upload Image',
        noEmpty:'cannot be empty!',
        needUploadImg:'Please upload pictures!',
        addSuccessMsg:'Successfully Added！',
        editSuccessMsg:'Successfully Edited！',
        delSuccessMsg:'Successfully Deleted！',
        cancelSuccessMsg:'Canceled successfully！',
        saveSuccessMsg:'Saved successfully！',
        operateSuccessMsg:'Operated successfully！',
        clearLocalStorage:'Clear Cache',
        hasEmptyItem:'There are empty data items. Please fill them out before submitting!',
        more:'More',
        pickDate:"Please Select A Date",
        summary:'Summarize All',
        weekSummary:'Weekly Summary',
        normal:'Normal',
        canceled:'Cancelled',
        selectConfirmMsg:'Are you sure about the selected item? Clicking OK will save the data',
        km:'KM',
        top:'Top',
        export:'Export',
        rollBack:'Version Rollback',
        nextPage:'Next',
        prevPage:'Previous',
        total:'Total',
        rows:'Rows',
        zh:'CH',
        en:'EN',
        de:'DE',
        cancelEdit:'Cancel Edit',
        finish:'Finish',
        fetchTip:'Support fuzzy search',
        downlaoding:'Downloading...',
        link:'Fault Link',
    },
    msg:{
        deleteMsg:'Are you sure forbidden this data?',
        uploadMsg:'Firmware uploaded successfully!',
        forbiddenMsg:'Firmware disabled!',
        releaseMsg:'Please select a publishing environment!',
        limitMsg:'Please select a publishing limit!',
        limitValMsg:'Please enter a publishing limit value!',
        fileMsg:'Please select the firmware to upload!',
        cancelTip: 'Are you sure to cancel?',
        delMsg:'Are you sure delete this data?',
        firmwareDescMsg:'Please enter a firmware description(En)!',
        firmwareDescDeMsg:'Please enter a firmware description(De)!',
        firmwareDescFrMsg:'Please enter a firmware description(Fr)!',
        firmwareDescNLMsg:'Please enter a firmware description(NL)!',
    },
    menu:{
        notice:'Notice MGT.',
        firmware:'Firmware MGT.',
        appVersion:'APP Release MGT.',
        dataQuery:'Data Query',
        userData:'User Data',
        upgradeDiff:'EBike Data',
        vehicleSta:'EBike Data Statistic',
        ridePointSta:'Ride Point Data Statistic',
        powerOnTempSta:'Power On Temperature Statistic',
        powerOnTimesSta:'Power On Times Statistic',
        userDataBoard:'Data Board',
        faultDataBoard:'Fault Data Board',
        historyFaultInfo:'EBike History Fault Info',
        upgradeLog:'Upgrade Log',
        faultCodeMaintenance:'Fault Code Maintenance',
        partsVersionDistribution:'Parts Distribution',
        partsVersionStatistic:'Parts Software Version Statistic',
        upgradeRules:'Upgrade Rules',
        partsQuery:'Parts Query',
        hardwareQuery:'Hardware Query',
        fault:'Fault',
        file:'File MGT.',
    },
    home:{
        morning:'Good Morning!',
        forenoon:'Good Forenoon!',
        noon:'Good Noon!',
        afternoon:'Good Afternoon!',
        evening:'Good Evening!',
        welcome:'Welcome to HEPHA Ecological Platform!',
    },
    firmware:{
        order_number:'No.',
        project_no:'Project No.',
        company_id:'Company ID',
        part_no:'Part No.',
        hardware_version:'Hardware Version',
        software_version:'Software Version',
        creator:'Creator',
        create_time:'Create Time',
        file_size:'File Size',
        firmwareStatus:'Firmware Status',
        environment:'Release Environment',
        release_limit:'Release Limit',
        operate:'Operate',
        file:'Upload Firmware',
        release_limit_val:'Limit Values',
        terminate_time:'Terminate Time',
        firmware_desc:'Firmware Desc(En)',
        firmware_desc_de:'Firmware Desc(De)',
        firmware_desc_fr:'Firmware Desc(Fr)',
        firmware_desc_nl:'Firmware Desc(NL)',
        frameNumber:'Frame Number',
        assemblyCode:'Assembly Code',

        not_used:'Not Used',
        published:'Published',
        testing:'Testing',
        market_environment:'Market Environment',
        production_environment:'Production Environment',
        testing_environment:'Testing Environment',
        unlimited:'Unlimited',
        base:'Base',
        grayscale:'Grayscale',
        personal:'Personal',
    },
    appVersion:{
        platform:'Platform',
        current_version:'Current Version',
        alert_flag:'Alert Flag',
        platform_path:'Platform Path',
        tenant_name:'Tenant',
        hepha:'HEPHA',
        gobao:'GOBAO',
        Android:'ANDROID',
        iOS:'IOS',
        status:'Status',
        release_id:'Release ID',
        create_time:'Create Time',
        current_version_eg:'eg: 1.0.0',
        current_version_formatTip:'The version format is incorrect!',
    },
    dataSearch:{
        query_data_empty: 'Query data empty',
        statistic_type: 'Statistic Type',
        fix_span: 'Fix span',
        real_time_spam: 'Real time span'
    },
    cycling:{
        frame_number:'Frame Number',
        user_id:'User ID',
        distance:'Distance(m)',
        ride_no:'Ride No.',
        cost_time:'Cost Time(s)',
        power_consumption:'Power Consumption',
        off_mode:'OFF Mode',
        eco_mode:'ECO Mode',
        tour_mode:'TOUR Mode',
        turbo_mode:'TURBO Mode',
        man_power:'Man Power',
        motor_power:'Motor Power',

        email:'Email',
        frame_number:'Frame Number',
        triple_id:'Triple ID',
        date:'Date',
        input_email:'Please Input Email',
        input_frame_number:'Please Input Frame Number',
        input_triple_id:'Please Input Assembly Code',
        search:'Search',
        export_excel:'Download Ride Points',
        downLoad:'Download Fault Data',
        to:'To',
        start_date:'Start Date',
        end_date:'End Date',
        searching:'Querying, please wait...',
        dateMsg:'Please select a date range',
        downLoadMsg:'Downloading desperately',
        frameNumberMsg:'Please enter the frame number',
        number:'Number'
    },
    userData:{
        frame_number:'Frame Number',
        vehicle_name:'EBike Name',
        color:'Color',
        max_torque:'Max Torque',
        change_motor:'Replace Motor',
        category:'EBike Category',
        vehicle_status:'EBike Status',
        triple_id:'Triple ID',
        triple_id2:'Assembly No.',
        use_markup:'Use Markup',
        offline_status:'Offline Status',
        part_no:'Part No.',
        part_name:'Part Name',
        assembly_no:'Assembly No.',
        software_version:'Software Version',
        hardware_version:'Hardware Version',
        latest_software_version:'Latest Software Version',
        latest_hardware_version:'Latest Hardware Version',
        cycling_mileage:'Riding Mileage',
        cycling_mileage2:'Riding Mileage(KM)',
        vehilce_cycling_mileage:'Riding Mileage(KM)',
        cost_time:'Cost Time',
        vehicle_cost_time:'Total Riding Time(H)',
        app_version:'App Version',
        start_timestamp:'Start Timestamp',
        end_timestamp:'End Timestamp',
        auth_result:'Auth Result',
        auth_desc:'Auth Desciption',
        auth_time: 'Auth Time',
        secret_key: 'Secret Key',
        success: 'Success',
        failed: 'Failed',
        triple_mileage:'Triple Mileage(KM)',
        trampling_laps:'Trampling Laps',
        ride_no:'Ride No.',
        faults:'Fault times',
        repairs:'Repair times',
        upgrades:'Upgrade times',
        upgrades_suc:'Upgrade Success times',
        upgrades_fail:'Upgrade Failed times',
        binds:'Bind times',
        torque_changes:'Torque Change times',
        settings:'Setting times',
        user_identifier:'User Identifier',

        userActivationRate:'User Activation Rate',
        active:'Number of activators',
        inactive:'Number of inactive people',

        totalSale:'Total Sales',
        activationNum:'Total Number Of Activated Users',
        lastWeekActivationNum:'Number Of Activated Users Last Week',
        lastWeekSegmentCount:'Number Of Active Users Last Week',

        cityDistribution:'Activate User City Distribution',

        activated:'Activated',
        unbound:'Unbound',
        maintenance:'Maintenance',
        main_vehicle:'Main EBike',
        free_vericle:'Free Vericle',
        delivery:'Delivery',

        country:'Country',
        subdivisions:'State',
        city:'City',
        num:'Number of active users',

        editTorque:'Edit Torque',
        saveTorque:'Save Torque',
        torqueUpgradeRecord:'Torque Upgrade',
        init_torque:'Init Torque',
        target_torque:'Target Torque',
        status:'Status',
        create_time:'Create Time',
        cancel_time:'Cancel Time',

        getBatteryKey:'Get Motor Key',
        unbindBikeUser:'Unbind User',
        deletePart:'Delete',
        deleteAllPart:"Delete All Part",
        unbindBikeUserConfirmMsg:'Are you sure to unbind the ebike user?',
        deleteAllPartConfirmMsg:'Are you sure to delete all parts?',
        deletePartConfirmMsg:'Are you sure to delete part?',

        currentSetting: 'Current Setting',
        settingRecord: 'EBike Setting',
        repairRecord: 'EBike Repair',
        authRecord: 'EBike Auth',
        bindRecord:'EBike Bind',

        applyReplaceMotor:'Replace Motor',
        motorApplyRecord:'Motor Replace',
        replaceConfig:'Update Config',

        init_triple_id:'Init Triple ID',
        target_triple_id:'Target Triple ID',
        apply_status:'Replace Status',
        apply_create_time:'Create Date',


        auto_light:'Auto Light',
        beeper:'Beeper',
        language:'Language',
        low_battery:'Low Battery',
        phone_key:'Phone Key',
        units:'Units',
        assist_level:'Assist Level',
        maximum_torque:'Maximum Torque',
        mode:'Mode',
        recognition_sensitivity:'Recognition Sensitivity',
        start_response:'Start Response',
        setting_time:'Setting Time',
        repair_category:'Repair Category',
        repair_start_time:'Repair Start Time',
        repair_end_time:'Repair End Time',
        repair_status:'Repair Status',
        mes_sync:'MES Sync',
        bind_category:'Bind Category',
        bind_time:'Bind Time',
        bind_mode_category:'Bind Mode Category',
        frame:'Frame',
        assembly:'Assembly',
        

        torqueEditSuccessMsg:'Torque editing successful, waiting for upgrade！',
        email:'Email',
        input_email:'Please enter your email address',
        categoryEditSuccessMsg:'category save successful',
        editCategory:'Edit Category',
        marketVehicle:'Market EBike',
        testVehicle:'Test EBike',

        table:"Table",
        map:'Map',
        confirmMsg:'Are you sure you want to apply for motor replacement?',
        confirmMsg2:'Are you sure to apply for updating the configuration?',
        finish:'Finish',
        waitReplace:'Waiting for replacement',
        cancel:'Cancel',
        canceled:'Canceled',
        applyed:'Applied for',
        replace_category:'Category',

        binding:'Binding',
        unbinding:'Unbinding',
        open:'Open',
        end:'End',
        repairing:'Repairing in progress',
        repair:'Repair',
        returnGoods:'Return of goods',
        synchronized:'Synchronized',
        abnormal:'Abnormal',

        turnOn:'Turn On',
        turnOff:'Turn Off',
        german:'German',
        waitUpgrade:'Waiting for upgrade',
        download_parts_version:"Download Parts Version Data",
        download_vehicle:"Export EBike Data",
        statistics_vehicle:"Statistics EBike Data",
        statistics_close:"Close statistics data",

        editAndApplay:'Edit/Apply',
        log:'Log',
        record:'Record',
        more:'More',

        batteryKey:'Battery Key',
        project_no:'Project No.',
        company_id:'Company ID',
        unboundSuccessful:'Unbind successfully!',
        deleteSuccessful:'Delete Successfully!',
        input_triple_id:'Assembly No. (accurate query)',

        summery:'Summary',
        cadence:'Cadence(times)',
        upgradeLog:'Upgrade Log',
        powerLog:'Power On Log',
        torqueLog:'Upgrade Torque Log',
        motorReplaceLog:'Replace Motor Error Log',
        user_id:'User Identifier:',

        QRCode:'Motor QR Code',
        barCode:'EBike Bar Code',
        rank:'Rankink List',
        top10:'Top 10',
        top20:'Top 20',
        top50:'Top 50',
        top100:'Top 100',
        chartTitle:'EBike Total Mileage(KM)',
        chartTitle2:'User Total Mileage(KM)',
        downloadMile:'Export EBike/User Total Mileage',
        totalMile:'EBike and User Total Mileage Data',

        downloadRawData:'Export Raw Data',
        downloadMotor:'Export Motor Raw Data',
        downloadBattery:'Export Battery Raw Data',
        downloadDisplay:'Export Display Raw Data',
        downloadFault:'Export Fault Raw Data',

        motorRawData:'MCU Raw Data',
        batteryRawData:'BMS Raw Data',
        displayRawData:'Display Raw Data',
        faultRawData:'Fault Raw Data',

        motor:'Motor',
        battery:'Battery',
        display:'Display',
        fault:'Fault',

        selectTip:'Please select the data to export',
        dateRange:'Date range',
        plc:'PLC',
        can:'CAN',

        delMsg:'Are you sure to delete? After deletion, click 【Save】 to take effect!',
        versionTitle:'Config Info Historical Versions',
        addConfig:'Add Configs',
        historyVersion:'View Historical Versions',
        versionDate:'Version Date',
        creatorId:'Creator ID',
        rollBackSuccess:'Version rollback successful!',
        confirmRollBackTip:'Are you sure to roll back to this version?',
        noVersionData:'No Version Data',
        createTimestamp:'Create Timestamp',
        configInfoConfirm:'Config Info Confirm',
        saveConfigTip:'Please add configs!',
        valueMaxTip:'Cannot exceed the maximum value!',
        valueMinTip:'Cannot be less than the minimum value!',
        confirmConfigInfoMsg:'Please confirm the config information!',
        cancelTorqueUpgradeMsg:'Are you sure to cancel the torque upgrade?',
        cancelMotorApplyMsg:'Are you sure to cancel the motor replacement application?',

        restoreOffline:'Restore Offline',
        finish_time:'Finish Time',
        restoreOfflineMsg:'Are you sure to restore offline?',

        simplifyData:'Simplify Data',
        realtimeData:'Real-time Data',
        category:'Category',

        wheel_diameter:'Wheel Diameter',
        trolley_speed:'Trolley Speed(KM/H)',
        poweronPosition:'Power On Position',
        latitude_longitude:'Latitude/Longitude',
        elevation:'Elevation(M)',
        report_category:'Report Category',
        report_time:'Report Date',
        userID:'User ID',
        poweron_open:'Power on',
        poweron_close:'Power off',
        latitude:'Latitude',
        longitude:'Longitude',
    },
    file:{
        upload:'Upload File',
        category:'File Category',
        pictures:'Pictures',
        files:'Files',
        selectCategory:'Please select file category',
        selectFile:'Please select file',
        uploadBtn:'Upload',
        uploadSuccess:'File uploaded successfully!',
        file_name:'File Name',
        file_no:'File No.',
        file_size:'File Size',
        download_path:'Download Path',
        file_list:'File List',
        file_list_placeholder:'File list feature is under development...',
        create_time:'Create Time',
        byte:'Bytes',
    },

}